import { oauthScopes } from '../core/constants/oauthScopes'

export function redirectToGoogleAuth(completed_onboarding?: boolean) {
  const codeClient = window.google.accounts.oauth2.initCodeClient({
    client_id: import.meta.env.VITE_CLIENT_ID,
    scope: oauthScopes,
    ux_mode: 'redirect',
    redirect_uri: import.meta.env.VITE_REDIRECT_URL,
    state: encodeURIComponent(JSON.stringify({ completed_onboarding })),
  })
  codeClient.requestCode()
}
